
import { Link } from "react-router-dom";
import { Settings, User } from "lucide-react";

interface AccountTabsProps {
  activeTab: "subscription" | "profile";
}

export default function AccountTabs({
  activeTab
}: AccountTabsProps) {
  return (
    <div className="flex space-x-1 border-b mb-6">
      <Link to="/account/subscription">
        <div className={`px-4 py-2 border-b-2 flex items-center space-x-2 ${activeTab === "subscription" ? "border-primary text-primary font-medium" : "border-transparent hover:text-primary/80"}`}>
          <Settings size={16} />
          <span>Subscription</span>
        </div>
      </Link>
      <Link to="/account/profile">
        <div className={`px-4 py-2 border-b-2 flex items-center space-x-2 ${activeTab === "profile" ? "border-primary text-primary font-medium" : "border-transparent hover:text-primary/80"}`}>
          <User size={16} />
          <span>Profile</span>
        </div>
      </Link>
    </div>
  );
}
